import React, { Component } from "react";
import { Link } from 'react-router-dom';
import Header from './Header';
import Menu from './Menu';
import NextPrev from './NextPrev';
import {QUESTION} from '../services/Questions';
import Check from './Check';
import Loader from './Loader';
import '../assets/css/question.css';
import '../assets/css/custom.css';

class Questions extends Component {
    
    constructor(props)
    {
        super(props);
        this.state = {
            questionData:'',
            totalQuestion:0,
            currentQuestionIndex:0,
            currentQuestion:'',
            currentQuestionOption:'',
            currentQuestionAnswer:'',
            questionAnswers: new Array(),
            updateQuestionAnswers: new Array(),
            complainDetails:this.props.getComplainData.complainTypeDetails,
            nextStep:5,
            prevStep:3,
            checkedItems: new Map(),
            prevQuestionIndexes: [],
            isLoading : true,
            showInput : 0,
            optionInputFields : new Array(),

        };
        this.nextQuestion               = this.updateNextQuestion.bind(this);
        this.addCurrentOptionAnswers    = this.addCurrentOptionAnswers.bind(this);
        this.updateNextQuestion         = this.updateNextQuestion.bind(this);
        this.handlePrevAction           = this.handlePrevAction.bind(this);
        
        
    }

    componentWillMount()
    {   
        //Get data from API's
        let QuestionsData = QUESTION.getQuestionsByComplainType(this.state.complainDetails.id).then(res => {
            
            if(res.data.header.error==0)
            {   
                //Set Question Data
                this.setState({
                    questionData: res.data.body.details,
                    isLoading: false,
                });
                this.setState({
                    totalQuestion: this.state.questionData.length,
                });
                //Extract 1st Question a/c to paren_question_id = 0
                var ref = this;
                Object.values(res.data.body.details).forEach(function(row,key) 
                {   
                    let branchingData = row.branchingQuestionData;
                    if(branchingData.length == 0)
                    {   
                        let index = new Array();
                        index.push(key);

                        //Set 1st Question , Question Options,Current Question Index 
                        ref.setState({
                            currentQuestion: row,
                            currentQuestionOption: row.options,
                            prevQuestionIndexes : index,
                            currentQuestionIndex:key
                        });
                    }
                })

                //Set states If user comes from in-complate narrative/update 

                this.setState({
                    checkedItems: this.props.checkedItems,//default checked items
                    questionAnswers : this.props.questionAnswersData,//question answers of last complain types
                    optionInputFields : this.props.optionInputFields,//question option inputs fields text of last complain types
                    showInput : this.props.showInput,//question option inputs fields show of last complain types
                  });
                
            }
            else
            {
                this.setState({
                    isLoading: false,
                });
                alert('No Question Available');
            }
        }).catch(err => {
            this.setState({
                isLoading: false,
            });
            alert('No Question Available');
            return err;
        });
        
    }
    handlePrevAction = (e)=>{
        this.props.handleNextPrevSteps(this.state.prevStep);
    }
    
    updateNextQuestion    = (e) =>
    {   
        let questionData = this.state.questionData;
        let addQuestionInArray = true;

        let checkedItems = this.state.checkedItems;
        let _questionOptions = this.state.currentQuestionOption;
        var ref = this;
        Object.values(_questionOptions).forEach(function(row,key) 
        {   
            if(ref.state.checkedItems.get(row.id))
            {   
                //ref.addCurrentOptionAnswers.bind(this,row.id,key,row.narrative_text,row.parent_question_id,row.required_input,row.sort_order)
                const answers                   = new Array();
                answers.push({
                    option_id:row.id,
                    question_id:row.question_id,
                    sort_order:row.sort_order,
                    narrative_text:row.narrative_text,
                    parent_question_id:row.parent_question_id,
                    required_input:row.required_input,
                    required_input_text:ref.state.optionInputFields[row.id],
                });
                const _questionAnswers           = ref.state.questionAnswers;
                _questionAnswers[ref.state.currentQuestionIndex] = answers[0];
               
                ref.setState({
                    questionAnswers : _questionAnswers
                });
            }
            
        });
       //Check user select any option for current question
        if(this.state.questionAnswers[this.state.currentQuestionIndex])
        {   
            
            let currentQuestionIndex    = this.state.totalQuestion;
            let prevQuestionIndexes     = this.state.prevQuestionIndexes;
            const questionAnswers       = this.state.questionAnswers;
            const updateQuestionAnswers = this.state.updateQuestionAnswers;
            let currentQuestionAnswer   = this.state.questionAnswers[this.state.currentQuestionIndex]
            
            //Check option have required input
            if(currentQuestionAnswer.required_input==1 )
            {   
                if(!currentQuestionAnswer.required_input_text)            
                {   
                    addQuestionInArray = false;
                }
            }
            if(!addQuestionInArray)
            {
                alert('please fill input field');
            }
            else
            {
                //const answers               = new Array();
                //answers.push(this.state.questionAnswers[this.state.currentQuestionIndex]);
                
                /** updateQuestionAnswers this is only for when user update narrative */
                updateQuestionAnswers[this.state.currentQuestionIndex] = this.state.questionAnswers[this.state.currentQuestionIndex];
                
                //updateQuestionAnswers.push(this.state.questionAnswers[this.state.currentQuestionIndex]);
                this.setState({
                    updateQuestionAnswers : updateQuestionAnswers
                });

                /** Extract next question option */
                let selectedOptionId    = currentQuestionAnswer.option_id;
                let selectedQuestionId  = currentQuestionAnswer.question_id;
                
                Object.values(questionData).forEach(function(row,key) 
                {   
                    let branchingQuestionData = row.branchingQuestionData;
                    Object.values(branchingQuestionData).forEach(function(r,k) 
                    {   
                        //alert('asdasdsad');
                        if(
                            r.parent_question_option_id == selectedOptionId &&  
                            r.parent_question_id        == selectedQuestionId
                            )
                            {   
                                /** Extract next question index */
                                currentQuestionIndex = key;
                                prevQuestionIndexes.push(key);
                            }
                        });
                        
                    
                })
                //let currentQuestionIndex = this.state.currentQuestionIndex+1;
                if(currentQuestionIndex < this.state.totalQuestion)
                {   
                    
                    this.setState({
                        prevQuestionIndexes : prevQuestionIndexes
                    })
                    /** Set next question here */
                    this.updateCurrentQuestion(currentQuestionIndex);
                }
                else
                {   
                    /** SAVE ALL DATA IN MASTER COMPONENT AND GO TO PATIENT NARRATIVE*/    
                    this.props.setCheckedItems(this.state.checkedItems);
                    this.props.setOptionInputFields(this.state.optionInputFields);
                    this.props.setInputField(this.state.showInput);
                    
                    if(this.props.isNarrativeUpdate)
                    {  
                        this.props.setQuestionAnswersData(this.state.updateQuestionAnswers);
                        
                    }
                    else
                    {   
                        this.props.setQuestionAnswersData(this.state.questionAnswers);
                    }
                    this.props.handleNextPrevSteps(this.state.nextStep);
                }
            }
        }
        else
        {
            alert('please select at least one option');
        }
       
    } 
    updatePrevQuestion = (props) =>
    {   
       
        let prevQuestionIndexes = this.state.prevQuestionIndexes;
        const lastIndex         = prevQuestionIndexes[(prevQuestionIndexes.length)-1];
        prevQuestionIndexes.pop();
        if(prevQuestionIndexes.length > 0)
        {   
            let questionAnswers = this.state.questionAnswers;
            delete questionAnswers[lastIndex]
            let currentQuestionIndex = prevQuestionIndexes[(prevQuestionIndexes.length)-1]
            this.setState({
                prevQuestionIndexes : prevQuestionIndexes,
                questionAnswers : questionAnswers
            })
            
            this.setState({
                currentQuestionIndex:currentQuestionIndex,
            });
            this.updateCurrentQuestion(currentQuestionIndex);
        }
        else
        {
            this.handlePrevAction();
        }
        // else
        // {
        //     this.setState({
        //         currentQuestionIndex:0
        //     })
        // }
       
       
    } 

    addInputTextInOptionAnswers = (e)=>
    {   
        const currentQuestionIndex      = this.state.currentQuestionIndex;
        const questionAnswers           = this.state.questionAnswers;
        questionAnswers[currentQuestionIndex]['required_input_text'] = e.target.value;
        let inputFields = this.state.optionInputFields;
        inputFields[e.target.id] = e.target.value;
        this.setState({
            optionInputFields : inputFields
        });
        
    } 
    addCurrentOptionAnswers             = (id,key,narrative_text,parentQuestionId,required_input,sort_order) =>
    {   
        const optionId                  = id;
        const parent_question_id        = parentQuestionId;
        const optionIndex               = key;
        const questionId                = this.state.currentQuestion.id;
        const currentQuestionIndex      = this.state.currentQuestionIndex;
        const questionAnswers           = this.state.questionAnswers;
        
        // Show input field if reuried input 1
        this.setState({
            showInput:optionId
        })
        
        const answers                   = new Array();
        answers.push({
            option_id:optionId,
            question_id:questionId,
            sort_order:sort_order,
            narrative_text:narrative_text,
            parent_question_id:parent_question_id,
            required_input:required_input,
            required_input_text:this.state.optionInputFields[optionId],
        });
        questionAnswers[currentQuestionIndex] = answers[0];
       
        this.setState({
            questionAnswers : questionAnswers
        });
        
        var ref = this;
        Object.values(this.state.currentQuestionOption).forEach(function(row,key) 
        {
            ref.setState(prevState => ({ 

                checkedItems: prevState.checkedItems.set(row.id,) }
            ));
        })
        this.setState(prevState => ({ 

            checkedItems: prevState.checkedItems.set(id,true) }
        ));
    }
    
    
    updateCurrentQuestion   = (index) => 
    {   
        
        const currentQuestion   = this.state.questionData[index];
        const questionOption    = this.state.questionData[index].options;

        this.setState({
            currentQuestionIndex:index,
            currentQuestion: currentQuestion,
            currentQuestionOption: questionOption,
        });
        
    }
    displayInputText = (id)=>
    {
        return this.state.optionInputFields[id];
    }
  render() {
      var style = {
          'minWidth':'100%',
          'width':'auto',
      }
    return (
        <React.Fragment>
            <Header title="Interview Questions" titleImage="ic-conversation.png" />
            <Menu />
            <section className="chief-complain sec--question">
                {/* <div className="banner" >
                    <img src={require("../assets/img/bg/new-banner-question.jpg")} style={style} alt="" />
                </div> */}
                <div className="questionrow">
                    <div className="question">
                        <label>Question</label>
                        <h3>{this.state.currentQuestion.name}</h3>
                    </div>
                </div>
                <div style={{display: 'flex', justifyContent: 'center'}}>
                    {
                      this.state.isLoading!=0 &&
                      <Loader/>
                    }
                </div>
                <div className="content">
                    <div className="multybgRow">
                        <ul className="checkList">
                            {Object.values(this.state.currentQuestionOption).map((item, i) => (
                                <Check displayInputText={this.displayInputText} 
                                parent_question_id={item.parent_question_id} 
                                addInputTextInOptionAnswers={this.addInputTextInOptionAnswers} 
                                key={item.id} item={item} i={i} 
                                addCurrentOptionAnswers={this.addCurrentOptionAnswers} 
                                checked={this.state.checkedItems.get(item.id) }
                                showInput={this.state.showInput}
                                sort_order={this.state.currentQuestion.category_order}
                                />
                            ))}
                        </ul>
                    </div>
                </div>
            </section>
            
            <div className="sec-btn">
            
                <Link to="#" className="btn-img" onClick={this.updatePrevQuestion}>
                    <img src={require("../assets/img/icons/ic-prev.png")} alt="" />
                </Link>
            
            
            {
                (this.state.totalQuestion > 0 && this.state.currentQuestionIndex < this.state.totalQuestion) &&
                <Link to="#" className="btn-img " onClick={this.updateNextQuestion} >
                    <img src={require("../assets/img/icons/ic-next.png")} alt="" />
                </Link>
            }
                
            </div>

        </React.Fragment>
    );
  }
}

export default Questions;